import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { CalendarEvent, CalendarEventAction } from 'angular-calendar';
import { isSameDay, isSameMonth } from 'date-fns';
import * as moment from 'moment';
// tslint:disable-next-line: import-blacklist
import { Subject, Observable, Subscription } from 'rxjs';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { DAYS_OF_WEEK } from 'angular-calendar';
import { NgxSpinnerService } from 'ngx-spinner';

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
  green: {
    primary: '#098b1d',
    secondary: '#9bf8a9',
  },
};

@Component({
  selector: 'app-montaza-kalendar',
  templateUrl: './montaza-kalendar.component.html',
  styleUrls: ['./montaza-kalendar.component.scss'],
})
export class MontazaKalendarComponent implements OnInit {
  private _subscriptions: Subscription[] = [];
  private selectedProgram: any;

  public viewDate: Date = new Date();
  public activeDayIsOpen = false;
  public selectedDatum: any = new Date();
  public selectedEvent: CalendarEvent;
  public events: CalendarEvent[] = [];
  public weekStart = DAYS_OF_WEEK.MONDAY;

  refresh: Subject<any> = new Subject();

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter(iEvent => iEvent !== event);
        this.handleEvent('Deleted', event);
      },
    },
  ];

  @Input() set program(value) {
    if (value) {
      this.selectedProgram = value;
    }
  }

  get program() {
    return this.selectedProgram;
  }

  @Input() view: string;
  @Input() programChanged: Observable<any>;
  @Input() reload: Observable<any>;

  @Output() zapocniMontazu: EventEmitter<any> = new EventEmitter<any>();
  @Output() otvoriDetaljeMontaze: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private renderer: Renderer2,
    private elRef: ElementRef,
    private _rtsBackendService: RtsBackendService,
    private _spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.changedProgram();
    this.loadEvents(this.viewDate);
  }

  changedProgram() {
    if (this.programChanged) {
      this.programChanged.subscribe(res => {
        this.selectedProgram = res;
        this.loadEvents(this.viewDate);
      });
    }
  }

  // tslint:disable-next-line: member-ordering
  modalData: {
    event: CalendarEvent;
    action: string;
  };

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
  }

  closeOpenMonthViewDay(event) {
    this.activeDayIsOpen = false;
    this.loadEvents(this.viewDate);
  }

  loadEvents(date: Date) {
    // januar je 0;
    this._spinner.show();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const montaze = this.getObsloadEventsFromMontaza(month, year);
    const spice = this.getObsLoadBrendiraneSpiceExistence(month, year);

    const obs = Observable.forkJoin(montaze, spice);

    obs.subscribe((result: any[]) => {
      const montazeEvent = this.mapMontazaServiceResult(result[0].ServiceData);
      const spiceEvent = this.mapSpiceResult(result[1].ServiceData);

      this.events = montazeEvent.concat(spiceEvent);
      this.refresh.next();
      this._spinner.hide();
    });
  }

  mapMontazaServiceResult(response): CalendarEvent[] {
    const events = [];
    if (response && response.length) {
      response.forEach(r =>
        events.push(this.createCalendarEventFromMontaza(r))
      );
    }

    return events;
  }

  mapSpiceResult(response): CalendarEvent[] {
    const events = [];
    if (response && response.length) {
      response.forEach(r =>
        events.push(this.createCalendarEventBrendiraneSpiceExistence(r))
      );
    }

    return events;
  }

  getObsLoadBrendiraneSpiceExistence(month: number, year: number) {
    const filter = `?programId=${this.selectedProgram.Id}&month=${month}&year=${year}`;

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSUGO_KALSPI,
      FormName.MontazaKalendar,
      EndpointTypes.GetAllEntities,
      filter,
      {},
      {},
      true
    );

    return this._rtsBackendService.fetchMediaPlanSettings(payload);
  }

  getObsloadEventsFromMontaza(month: number, year: number) {
    const filter = `?programId=${this.selectedProgram.Id}&month=${month}&year=${year}`;
    const events = [];

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMON_KLDR,
      FormName.MontazaKalendar,
      EndpointTypes.GetAllEntities,
      filter,
      {},
      {},
      true
    );

    return this._rtsBackendService.fetchMediaPlanSettings(payload);
  }

  createCalendarEventBrendiraneSpiceExistence(event): CalendarEvent {
    return {
      start: new Date(event.Datum),
      end: new Date(event.Datum),
      title: 'Postoje upisane brendirane špice.',
      color: colors.green,
      actions: this.actions,
      meta: {
        type: 'spica',
      },
    };
  }

  createCalendarEventFromMontaza(montaza): CalendarEvent {
    return {
      start: new Date(montaza.Datum),
      end: new Date(montaza.Datum),
      title: montaza.ProgramNaziv + ' ' + montaza.Datum.substring(0, 10),
      color:
        montaza.Status === 'Idle'
          ? colors.yellow
          : montaza.Status === 'Done'
          ? colors.blue
          : colors.red,
      actions: this.actions,
      meta: {
        type: 'montaza',
        createdBy: montaza.Kreirao,
        createdAt: montaza.DatumKreiranja.substring(0, 10),
        status:
          montaza.Status === 'Idle'
            ? 'Na čekanju'
            : montaza.Status === 'Done'
            ? 'Završen'
            : 'U izradi',
        opis: montaza.Opis,
        updatedAt: montaza.DatumIzmene
          ? montaza.DatumIzmene.substring(0, 10)
          : null,
        updatedBy: montaza.Izmenio,
      },
    };
  }

  customTemplate(events: CalendarEvent[], date) {
    if (events.length > 0) {
      let elementPrerendered = null;
      if (this.elRef.nativeElement.querySelector('.cal-open-day-events')) {
        elementPrerendered = this.renderer.selectRootElement(
          '.cal-open-day-events'
        );
        this.renderer.addClass(elementPrerendered, 'abc');
      }
      setTimeout(() => {
        let element = this.renderer.selectRootElement('.cal-open-day-events');
        const qs = this.elRef.nativeElement.querySelectorAll(
          '.cal-open-day-events'
        );
        if (qs.length > 1) {
          element = this.renderer.selectRootElement(
            '.cal-open-day-events:not(.abc)'
          );
        }
        if (elementPrerendered !== null) {
          this.renderer.removeClass(elementPrerendered, 'abc');
        }

        events.forEach((event, index) => {
          const spanColor = this.renderer.createElement('span');
          this.renderer.addClass(spanColor, 'cal-event');

          const color =
            event.meta != null &&
            event.meta.type &&
            event.meta.type === 'montaza'
              ? event.color.primary
              : colors.green.primary;

          this.renderer.setStyle(spanColor, 'background-color', color);

          const spanText = this.renderer.createElement('span');
          this.renderer.setStyle(spanText, 'margin', '0 10px');
          this.renderer.setStyle(spanText, 'cursor', 'pointer');
          const breakDiv = this.renderer.createElement('div');
          const text = this.renderer.createText(event.title);
          this.renderer.appendChild(spanText, text);
          this.renderer.appendChild(element, breakDiv);
          this.renderer.appendChild(element, spanColor);
          this.renderer.appendChild(element, spanText);
          // const deleteAction = this.renderer.createElement('a');
          // this.renderer.setStyle(deleteAction, 'margin', '0 10px');

          if (event.meta.type === 'montaza') {
            const detailsAction = this.renderer.createElement('a');
            // this.renderer.setStyle(deleteAction, 'cursor', 'pointer');
            this.renderer.setStyle(detailsAction, 'cursor', 'pointer');
            // const deleteActionFont = this.renderer.createElement('i');
            const detailsActionFont = this.renderer.createElement('i');
            // this.renderer.addClass(deleteActionFont, 'fas');
            // this.renderer.addClass(deleteActionFont, 'fa-fw');
            // this.renderer.addClass(deleteActionFont, 'fa-trash-alt');
            this.renderer.addClass(detailsActionFont, 'fa');
            this.renderer.addClass(detailsActionFont, 'fa-eye');
            // this.renderer.appendChild(deleteAction, deleteActionFont);
            // this.renderer.listen(deleteAction, 'click', ev => {
            //   this._modalService.openModal(
            //     'Da li ste sigurni da želite da obrišete montažu iz kalendara?',
            //     res => {
            //       if (res) {
            //         this.events.splice(index, 1);
            //         this.renderer.removeChild(element, breakDiv);
            //         this.renderer.removeChild(element, spanColor);
            //         this.renderer.removeChild(element, spanText);
            //         this.renderer.removeChild(element, deleteAction);
            //       }
            //     }
            //   );
            // });
            this.renderer.appendChild(detailsAction, detailsActionFont);
            this.renderer.listen(detailsAction, 'click', ev => {
              this.selectedEvent = event;
              this.otvoriDetaljeMontaze.next(this.selectedEvent);
            });
            this.renderer.listen(spanText, 'click', ev => {
              this.selectedDatum = moment(event.start).format('YYYY-MM-DD');
              setTimeout(() => {
                this.zapocniMontazu.next(this.selectedDatum);
              }, 0);
            });
            // this.renderer.appendChild(element, deleteAction);
            this.renderer.appendChild(element, detailsAction);
            this.renderer.removeClass(element, 'abc');
          }
        });
      }, 1);
      this.initiateZapcniMontazu(events, date);
    } else {
      this.initiateZapcniMontazu(events, date);
    }
  }

  initiateZapcniMontazu(events: CalendarEvent[], date) {
    const montazaEvents = events.filter(
      e => e.meta != null && e.meta.type && e.meta.type === 'montaza'
    );

    // Ukoliko nema montaze za datum probaj da kreiras novu.
    if (montazaEvents.length < 1) {
      this.selectedDatum = moment(date).format('YYYY-MM-DD');
      this.activeDayIsOpen = false;
      setTimeout(() => {
        this.zapocniMontazu.next(this.selectedDatum);
      }, 0);
    }
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }

      this.selectedDatum = moment(date).format('YYYY-MM-DD');
      this.viewDate = date;
      this.customTemplate(events, date);
    }
  }

  atClickedEvent({ event }: { event: CalendarEvent }) {
    this.selectedDatum = moment(event.start).format('YYYY-MM-DD');
    this.zapocniMontazu.emit(this.selectedDatum);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/montaza/montaza-kalendar/montaza-kalendar.component.ts